import { Delete, Edit } from '@mui/icons-material';
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { IInventoryOption } from '../../../../Interfaces/IInventoryOption';
import { IRealEstatePurchaseContractInventoryOption } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipRealEstate/IRealEstatePurchaseContractInventoryOption';
import { CreateOrUpdateRealEstateInventoryOptionDialog } from './CreateOrUpdateRealEstateInventoryOptionDialog';

interface IProps {
  inventoryOptionArray: IRealEstatePurchaseContractInventoryOption[];
  setInventoryOptionArray: (
    arr: IRealEstatePurchaseContractInventoryOption[]
  ) => void;
  inventoryOptions: IInventoryOption[];
}

export const RealEstateInventoryOptions: React.FC<IProps> = ({
  inventoryOptionArray,
  setInventoryOptionArray,
  inventoryOptions,
}) => {
  const [isMount, setIsMount] = useState(false);
  const [selectedInventoryOption, setSelectedInventoryOption] =
    useState<IRealEstatePurchaseContractInventoryOption>();

  return (
    <>
      <Typography variant='h5' sx={{ mt: 2, mb: 1 }}>
        Anlagen
        <br />
        <Typography>
          Neben dem eigentlichen Grundstück können ebenfalls{' '}
          <u>Inventar und Anlagen mitverkauft</u> werden. Bitte erfassen Sie
          sämtliches Inventar (Einbauküche, Möbel etc.) und Anlagen
          (Fotovoltaikanlagen, Bootssteg etc.), welche mitverkauft werden.
        </Typography>
      </Typography>

      <Button
        variant='contained'
        sx={{ float: 'right' }}
        onClick={() => setIsMount(true)}
      >
        Hinzufügen
      </Button>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Anzahl</TableCell>
            <TableCell>Bezeichnung</TableCell>
            <TableCell>Beschreibung</TableCell>
            <TableCell>Aktionen</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {inventoryOptionArray.map((o, i) => (
            <TableRow key={i}>
              <TableCell>{o.Amount}</TableCell>
              <TableCell>{o.Title}</TableCell>
              <TableCell>{o.Description ?? '-'}</TableCell>
              <TableCell>
                <IconButton
                  onClick={() => {
                    setSelectedInventoryOption(o);
                    setIsMount(true);
                  }}
                >
                  <Edit />
                </IconButton>
                <IconButton
                  onClick={() =>
                    setInventoryOptionArray(
                      inventoryOptionArray.filter(
                        y => y.idInventoryOption !== o.idInventoryOption
                      )
                    )
                  }
                >
                  <Delete />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {isMount && (
        <CreateOrUpdateRealEstateInventoryOptionDialog
          selectedInventoryOption={selectedInventoryOption}
          inventoryOptions={inventoryOptions}
          setInventoryOptionArray={updater =>
            setInventoryOptionArray(updater(inventoryOptionArray))
          }
          unmount={() => {
            setIsMount(false);
            setSelectedInventoryOption(undefined);
          }}
        />
      )}
    </>
  );
};
